module.exports = __webpack_public_path__ + "img/95.8.TSS.35c63b17.png";